import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterOutlet, Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BuilderService } from 'src/app/builder-services/builder.service';
import { LoginService } from 'src/app/login/login.service';

@Component({
  selector: 'app-generate-app',
  standalone: true,
  imports: [RouterOutlet, RouterLinkActive, RouterLink, ReactiveFormsModule, CommonModule, TranslateModule],
  templateUrl: './generate-app.component.html',
  styleUrl: './generate-app.component.scss'
})
export class GenerateAppComponent implements OnInit {
  private currentUrl: string = '';
  private prevUrl: string = '';

  constructor(public loginService: LoginService, private router: Router, public builderService: BuilderService) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Save the previous URL before updating currentUrl
        this.prevUrl = this.currentUrl;
        // Update the current URL after navigation
        this.currentUrl = event.urlAfterRedirects;
      });
  }
}